//@ts-nocheck 

import styled from "styled-components";
import Col from "../../../atoms/GridSystem/Col.styles";

export const Register = styled.div`
  min-height: 100svh;
  background-color: #D7EDDC;

  ${Col} {
    height: 100svh!important;
    overflow-y: scroll;
    padding-top: ${({ theme }) => theme.rem(32)};
    padding-bottom: ${({ theme }) => theme.rem(32)};

    ${({ theme }) => theme.mediaQuery.md(`
      padding-top: ${theme.rem(48)};
      padding-bottom: ${theme.rem(48)};
      padding-right: ${theme.rem(48)};
    `)}
  }
`

export const RegisterItem = styled.div`
  width: 100%;

  ${({ theme }) => theme.mediaQuery.xl(`
    width: 50%;
  `)};

  &:first-child {
    padding: ${({ theme }) => theme.rem(32)};
    height: 100svh;
    overflow-y: scroll;

    ${({ theme }) => theme.mediaQuery.xl(`
      padding: ${theme.rem(80)};
    `)}
  }

  &:last-child {
    display: none;

    ${({ theme }) => theme.mediaQuery.xl(`
      display: block;
    `)}
  }
`

export const RegisterFormWrapper = styled.div` 
  background-color: #F6FAF3;
  padding: ${({ theme }) => theme.rem(32)};
`

export const RegisterFormSignup = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.rem(8)};
  align-items: center;
`

export const RegisterFormSignupCTA = styled.div`
  text-decoration: underline;
  cursor: pointer;
`

export const RegisterImageWrapper = styled.div`
  width: 50%;
  position: absolute;
  min-height: 100svh;
  right: 0;
  top: 0;
  display: none;

  ${({ theme }) => theme.mediaQuery.lg(`
    display: block;
  `)}

  img {
    object-fit: cover;
    object-position: center;
  }
`

export const RegisterFormRow = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;

  &:not(:last-child) {
    margin-bottom: ${({ theme }) => theme.rem(16)};
  }

  ${({ theme }) => theme.mediaQuery.xl(`
    justify-content: space-between;
  `)}
`;

export const RegisterFormInputWrapper = styled.div`
  width: 100%;

  ${({ theme, fullWidth }) => theme.mediaQuery.xl(`
    width: ${fullWidth ? '100%' : '48%'};
    align-self: flex-start;
  `)}
`;

export const RegisterPasswordInstruction = styled.div`
  display: inline-flex;
  margin-right: ${({ theme }) => theme.rem(16)};
  i {
    font-size: ${({ theme }) => theme.rem(16)};
    margin-right: ${({ theme }) => theme.rem(4)};
  }
`

export const RegisterPrivacyText = styled.div`

`